export default __webpack_public_path__ + "images/Femur_Plane_dark.3a599aaf8d9b5ccde54cb423fc5acf3a.png";